import * as z from "zod/v4";

/**
 * Promote every AdvancedFlow doc sharing `flowRevisionId` on the team to live
 * by stamping `publishedAt`. All docs in the revision are updated in one
 * transaction so phases flip together.
 *
 * Revert reuses the same RPC: republishing an already-published revision just
 * refreshes its `publishedAt`, making it the latest live revision again.
 */
export const publishProcessingFlowRevision = {
  name: "publishProcessingFlowRevision" as const,
  input: z.object({ flowRevisionId: z.string() }),
  output: z.object({ flowIds: z.array(z.string()), publishedAt: z.date() }),
};
